// Utilitário para debug de autenticação
export const authDebug = {
  log: (message: string, data?: any) => {
    if (import.meta.env.DEV) {
      console.log(`[AUTH DEBUG] ${message}`, data || '')
    }
  },

  error: (message: string, error?: any) => {
    if (import.meta.env.DEV) {
      console.error(`[AUTH ERROR] ${message}`, error || '')
    }
  },

  logTokenInfo: async (token: string | null) => {
    if (!token || !import.meta.env.DEV) return

    try {
      // Decode JWT token to check expiration
      const payload = JSON.parse(atob(token.split('.')[1]))
      const exp = new Date(payload.exp * 1000)
      const now = new Date()
      const timeLeft = exp.getTime() - now.getTime()

      authDebug.log('Token info', {
        expiresAt: exp.toISOString(),
        timeLeft: `${Math.round(timeLeft / 1000 / 60)} minutes`,
        isExpired: timeLeft <= 0
      })
    } catch (error) {
      authDebug.error('Erro ao decodificar token', error)
    }
  }
}
